/* Five-second use-card videos: media is requested only after an intentional click. */
(function () {
  'use strict';

  if (window.EliteUseVideoDialog) {
    window.EliteUseVideoDialog.init(document);
    return;
  }

  var dialog, video, title, caption, status, closeButton, playButton, header, media;
  var mediaRatio = 1;
  var activeTrigger = null;
  var activeCard = null;
  var savedOverflow = null;
  var loadId = 0;
  var pointerStartedOutside = false;
  var supportedHandles = ['titanium-laser-pro-flashlight', 'ironclad-x1-xl-ultra-led'];

  function config() {
    var node = document.getElementById('EliteUseVideoConfig');
    if (!node) return null;
    try {
      var data = JSON.parse(node.textContent);
      return supportedHandles.indexOf(data.handle) !== -1 && Array.isArray(data.videos) ? data : null;
    } catch (error) {
      return null;
    }
  }

  function init(scope) {
    var data = config();
    if (data && data.handle === 'titanium-laser-pro-flashlight') return;
    if (data && data.handle === 'ironclad-x1-xl-ultra-led') { initInline(scope, data); return; }
    if (!data || typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
    var grids = [];
    if (scope.matches && scope.matches('.elite-use-grid')) grids.push(scope);
    scope.querySelectorAll('.elite-use .elite-use-grid').forEach(function (grid) { grids.push(grid); });
    grids.forEach(function (grid) {
      grid.querySelectorAll('article.elite-use-card').forEach(function (card, index) {
        if (!data.videos[index] || card.querySelector('.elite-use-video-trigger')) return;
        var heading = card.querySelector('.elite-use-caption h3');
        var label = heading && heading.textContent.trim() || 'Míralo en acción';
        var trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'elite-use-video-trigger';
        trigger.dataset.eliteUseVideoIndex = String(index);
        trigger.setAttribute('aria-label', 'Ver ' + label + ' — video');
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-controls', 'EliteUseVideoDialog');
        trigger.innerHTML = '<span class="elite-use-video-badge" aria-hidden="true"><svg viewBox="0 0 20 20" width="16" height="16" focusable="false"><path d="M6 3.8v12.4L16 10z" fill="currentColor"/></svg><span>Ver video</span></span>';
        card.appendChild(trigger);
      });
    });
  }

  function initInline(scope, data) {
    var videos = [];
    scope.querySelectorAll('.elite-use-card').forEach(function(card, index) {
      if (card.dataset.ironInline || !data.videos[index]) return;
      var photo = card.querySelector('img.elite-use-photo');
      if (!photo) return;
      card.dataset.ironInline = 'true';
      var clip = document.createElement('video');
      clip.className = 'elite-use-photo';
      clip.poster = photo.currentSrc || photo.src;
      clip.dataset.src = data.videos[index];
      clip.preload = 'none'; clip.autoplay = true; clip.loop = true;
      clip.muted = true; clip.defaultMuted = true; clip.playsInline = true; clip.controls = false;
      clip.setAttribute('muted', ''); clip.setAttribute('playsinline', '');
      clip.setAttribute('aria-label', card.querySelector('h3').textContent);
      photo.replaceWith(clip); videos.push(clip);
      var trigger = card.querySelector('.elite-use-video-trigger'); if (trigger) trigger.remove();
      clip.addEventListener('pause', function() { if (clip.ironVisible && !document.hidden && clip.readyState >= 2) clip.ironUserPaused = true; });
      clip.addEventListener('play', function() { clip.ironUserPaused = false; });
    });
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var clip = entry.target;
        clip.ironVisible = entry.isIntersecting && entry.intersectionRatio >= 0.5;
        clearTimeout(clip.ironTimer);
        if (!clip.ironVisible) { clip.pause(); return; }
        if (document.hidden || clip.ironUserPaused) return;
        clip.ironTimer = setTimeout(function() {
          if (!clip.ironVisible || document.hidden) return;
          if (!clip.getAttribute('src')) { clip.src = clip.dataset.src; clip.load(); }
          clip.play().catch(function() {});
        }, 1000);
      });
    }, {threshold:[0,0.5]});
    videos.forEach(function(clip) { observer.observe(clip); });
    document.addEventListener('visibilitychange', function() {
      videos.forEach(function(clip) {
        if (document.hidden) { clearTimeout(clip.ironTimer); clip.pause(); }
        else if (clip.ironVisible && !clip.ironUserPaused) clip.play().catch(function() {});
      });
    });
  }

  function viewportHeight() {
    if (!dialog) return;
    var viewport = window.visualViewport;
    var height = viewport ? viewport.height : window.innerHeight;
    var width = viewport ? viewport.width : document.documentElement.clientWidth;
    var gutter = width <= 600 ? 16 : 24;
    var maxWidth = Math.min(680, width - gutter);
    dialog.style.setProperty('--elite-use-vh', height + 'px');
    dialog.style.setProperty('--elite-use-width', maxWidth + 'px');
    media.style.aspectRatio = String(mediaRatio);
    if (!dialog.open) return;
    // Measure the copy at its actual width so the complete frame fits on short screens.
    for (var pass = 0; pass < 8; pass += 1) {
      var chromeHeight = header.getBoundingClientRect().height + caption.getBoundingClientRect().height + 2;
      var available = Math.max(1, height - gutter - chromeHeight);
      var nextWidth = Math.min(maxWidth, available * mediaRatio + 2);
      var currentWidth = dialog.getBoundingClientRect().width;
      if (nextWidth >= currentWidth - 0.5) break;
      dialog.style.setProperty('--elite-use-width', nextWidth + 'px');
    }
  }

  function playbackState(playing) {
    playButton.classList.toggle('is-playing', playing);
    playButton.classList.toggle('is-ended', video.ended);
    playButton.setAttribute('aria-label', playing ? 'Pausar video' : (video.ended ? 'Volver a reproducir el video' : 'Reproducir video'));
  }

  function playVideo() {
    if (!dialog.open || !video.hasAttribute('src')) return;
    var currentLoad = loadId;
    playbackState(true);
    showStatus('');
    var playback = video.play();
    if (playback && playback.catch) playback.catch(function (error) {
      if (currentLoad !== loadId || !dialog.open) return;
      playbackState(false);
      if (error.name === 'NotAllowedError') showStatus('Toca para reproducir.');
      else if (error.name !== 'AbortError') showStatus('No se pudo cargar el video. Ciérralo y vuelve a intentarlo.');
    });
  }

  function showStatus(message) {
    if (!dialog || !dialog.open) return;
    status.textContent = message || '';
    status.hidden = !message;
  }

  function restoreStyle(element, value) {
    if (value.text) element.style.setProperty('overflow', value.text, value.priority);
    else element.style.removeProperty('overflow');
  }

  function cleanup() {
    loadId += 1;
    video.pause();
    video.removeAttribute('src');
    video.removeAttribute('poster');
    video.load();
    status.hidden = true;
    playbackState(false);
    if (savedOverflow) {
      restoreStyle(document.body, savedOverflow.body);
      restoreStyle(document.documentElement, savedOverflow.html);
      savedOverflow = null;
    }
    window.removeEventListener('resize', viewportHeight);
    if (window.visualViewport) window.visualViewport.removeEventListener('resize', viewportHeight);
    var trigger = activeTrigger;
    activeTrigger = null;
    activeCard = null;
    pointerStartedOutside = false;
    if (trigger && trigger.isConnected) trigger.focus({ preventScroll: true });
  }

  function close() {
    if (dialog && dialog.open) {
      dialog.close();
      cleanup();
    }
  }

  function outside(event) {
    var box = dialog.getBoundingClientRect();
    return event.clientX < box.left || event.clientX > box.right ||
      event.clientY < box.top || event.clientY > box.bottom;
  }

  function buildDialog() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.id = 'EliteUseVideoDialog';
    dialog.className = 'elite-use-video-dialog';
    dialog.setAttribute('aria-labelledby', 'EliteUseVideoTitle');
    dialog.setAttribute('aria-describedby', 'EliteUseVideoCaption');
    dialog.innerHTML = '<header class="elite-use-video-head"><div><span class="elite-use-video-eyebrow">MÍRALO EN ACCIÓN</span><h2 id="EliteUseVideoTitle"></h2></div><button type="button" class="elite-use-video-close" aria-label="Cerrar video"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button></header><div class="elite-use-video-media"><video muted playsinline preload="none"></video><button type="button" class="elite-use-video-toggle" aria-label="Reproducir video"><span class="elite-use-video-play-icon" aria-hidden="true"><svg viewBox="0 0 24 24" width="25" height="25"><path d="M8 5v14l11-7z" fill="currentColor"/></svg></span></button><p class="elite-use-video-status" role="status" aria-live="polite" hidden></p></div><p class="elite-use-video-caption" id="EliteUseVideoCaption"></p>';
    document.body.appendChild(dialog);
    video = dialog.querySelector('video');
    title = dialog.querySelector('h2');
    caption = dialog.querySelector('.elite-use-video-caption');
    status = dialog.querySelector('.elite-use-video-status');
    closeButton = dialog.querySelector('.elite-use-video-close');
    playButton = dialog.querySelector('.elite-use-video-toggle');
    header = dialog.querySelector('header');
    media = dialog.querySelector('.elite-use-video-media');
    video.defaultMuted = true;
    playButton.addEventListener('click', function () {
      if (video.paused || video.ended) playVideo();
      else video.pause();
    });
    closeButton.addEventListener('click', close);
    dialog.addEventListener('close', function () {
      if (!dialog.open && savedOverflow) cleanup();
    });
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      close();
    });
    dialog.addEventListener('pointerdown', function (event) {
      pointerStartedOutside = event.target === dialog && outside(event);
    });
    dialog.addEventListener('click', function (event) {
      if (pointerStartedOutside && event.target === dialog && outside(event)) close();
      pointerStartedOutside = false;
    });
    video.addEventListener('waiting', function () { showStatus('Cargando video…'); });
    video.addEventListener('playing', function () { showStatus(''); playbackState(true); });
    video.addEventListener('pause', function () { playbackState(false); });
    video.addEventListener('ended', function () { playbackState(false); });
    video.addEventListener('loadedmetadata', function () {
      if (!dialog.open || !video.videoWidth || !video.videoHeight) return;
      mediaRatio = video.videoWidth / video.videoHeight;
      viewportHeight();
    });
    video.addEventListener('canplay', function () { showStatus(''); });
    video.addEventListener('error', function () {
      if (video.hasAttribute('src')) {
        playbackState(false);
        showStatus('No se pudo cargar el video. Ciérralo y vuelve a intentarlo.');
      }
    });
  }

  function open(trigger) {
    var data = config();
    var index = Number(trigger.dataset.eliteUseVideoIndex);
    var source = trigger.dataset.eliteUseVideoUrl || (data && data.videos[index]);
    if (!data || !source) return;
    var card = trigger.closest('article.elite-use-card, .tb-box-img');
    if (!card) return;
    buildDialog();
    if (dialog.open) return;
    var heading = card.querySelector('.elite-use-caption h3');
    var copy = card.querySelector('.elite-use-caption p');
    var photo = card.querySelector('img.elite-use-photo, img');
    title.textContent = trigger.dataset.eliteUseVideoTitle || (heading && heading.textContent.trim()) || 'Míralo en acción';
    caption.textContent = trigger.dataset.eliteUseVideoCaption || (copy && copy.textContent.trim()) || 'Míralo en acción.';
    video.setAttribute('aria-label', title.textContent);
    if (photo) video.poster = photo.currentSrc || photo.src;
    mediaRatio = photo && photo.naturalWidth && photo.naturalHeight ? photo.naturalWidth / photo.naturalHeight : 1;
    activeTrigger = trigger;
    activeCard = card;
    savedOverflow = {
      body: { text: document.body.style.getPropertyValue('overflow'), priority: document.body.style.getPropertyPriority('overflow') },
      html: { text: document.documentElement.style.getPropertyValue('overflow'), priority: document.documentElement.style.getPropertyPriority('overflow') }
    };
    viewportHeight();
    dialog.showModal();
    viewportHeight();
    document.body.style.setProperty('overflow', 'hidden');
    document.documentElement.style.setProperty('overflow', 'hidden');
    window.addEventListener('resize', viewportHeight);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', viewportHeight);
    closeButton.focus({ preventScroll: true });
    showStatus('Cargando video…');
    loadId += 1;
    video.muted = true;
    video.loop = false;
    video.src = source;
    video.load();
    playVideo();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('.elite-use-video-trigger');
    if (trigger) open(trigger);
  });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    if (activeCard && event.target.contains(activeCard)) close();
  });
  window.EliteUseVideoDialog = { init: init, close: close };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
})();

